const emptyArrays = (arr: any[]) => arr.every((o) => Object.keys(o).length === 0);
export default emptyArrays;
